interface SVGProps {
  style: React.CSSProperties;
  color: string;
}

const SVG = (props: SVGProps) => {
  const { color } = props;

  return (
    <svg style={props.style} xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none">
      <path d="M3.02539 15.1851V6.68506L9.02539 2.43506L15.0254 6.68506V15.1851H10.5254V10.2267H7.52539V15.1851H3.02539Z" fill={color} />
    </svg>
  );
};

export default SVG;
